export default function animaTestemunials() {
	const totalItensCarrossel = parseInt(
		document.querySelector('.carousel-testimonials .total').innerText
	);
	
const barra = document.querySelector('.wrap-testimonials .separator .barra');

function updateSepareteBarra(index) {
  if (!barra) return;

  const barraAltura = 100 / totalItensCarrossel;
  const top = index * barraAltura;

  barra.style.height = `${barraAltura}%`;
  barra.style.top = `${top}%`;
}

$('.carousel-testimonials').on('changed.owl.carousel', function(event) {
  const currentIndex = event.item.index - event.relatedTarget._clones.length / 2;
  const realIndex = (currentIndex % totalItensCarrossel + totalItensCarrossel) % totalItensCarrossel;

  updateSepareteBarra(realIndex);
});


}